export const DASH = '—';
